import React, { useEffect, useState } from 'react';
import { NavbarInterna } from "../componentes/navbarInterna";
import { ContainerAdministracion } from '../componentes/containerAdministracion';
import axios from "axios";
import { manejarError } from "../manejo_errores";
import { ContainerAdministracionInscriptos } from '../componentes/containerAdminInscriptos';
import { Link } from 'react-router-dom';


export const Administracion = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const [campeonatos, setCampeonatos] = useState([]);
  const [circuito, setCircuito] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [pilotos, setPilotos] = useState([]);
  const [carreras, setCarreras] = useState([]);
  const [gestionCarreras, setGestionCarreras] = useState([]);
  const [preInscriptos, setPreInscriptos] = useState([]);

  // console.log("sesion", sesion)
  useEffect(() => {
    fetchCampeonatos();
    fetchCircuitos();
    fetchCategorias();
    fetchPilotos();
    fetchCarreras();
    fetchResultados();
    fetchPreinscriptos();
  }, []);

  const fetchCampeonatos = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMINIO +
          `/campeonato/asociacion/${sesion.id_asociacion}`
      );
      if (response.status === 200) {
        setCampeonatos(response.data);
        // console.log("campe", response.data)
      } else {
        manejarAlertas("error","No se encontraron Campeonatos.");
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error))
    }
  };

  const fetchCircuitos = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/circuito/asociacion/${sesion.id_asociacion}`
      );
      if (response.status === 200) {
        setCircuito(response.data);
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error))
    }
  };

  const fetchCategorias = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/categoria/asociacion/${sesion.id_asociacion}`
      );
      if (response.status === 200) {
        setCategorias(response.data);
      } else {
        manejarAlertas("error", "No se encontró la categoría.");
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const fetchPilotos = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/piloto-asociacion/${sesion.id_asociacion}`
      );
      if (response.status === 200) {
        setPilotos(response.data);
      } else {
        manejarAlertas("error", "No se encontraron pilotos");
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const fetchCarreras = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMINIO + `/carrera/asociacion/${sesion.id_asociacion}`,
      );
      setCarreras(response.data);
    } catch (error) {
      manejarAlertas("error", "Error al obtener carreras.");
      console.error("Error al obtener carreras:", error);
    }
  };

  const fetchResultados = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/carrera/asociacion/${sesion.id_asociacion}`
      );
      const filtro = response.data
        .filter(carrera => carrera.campeonato.año == (new Date().getFullYear()))
        .filter(carrera => new Date(carrera.dia) < (new Date()))
      // console.log("carreras 2025", filtro)
      setGestionCarreras(filtro)
      // console.log("carreras", response.data)
     
    } catch (error) {
      manejarAlertas("error","Error al obtener carreras.");

      console.error("Error al obtener carreras:", error);
    }
  };

  const fetchPreinscriptos = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/pre-inscriptos/${sesion.id_asociacion}`);
      setPreInscriptos(response.data);
      // console.log("data", response.data)
    } catch (error) {
      manejarAlertas("error", "Error al obtener pre-inscriptos.");
    }
  }

  return (
    <>
      <section
        id="seccionAdministracionMenu"
        style={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "30px"
        }}
      >
        {sesion.permisos?.includes("PRE_INSCRIPCIONES") || sesion.super_admin == true ? (
          <div
            className='divPre'
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              maxWidth: "1200px",
              padding: "0 0px 0 20px"
            }}
          >
            {/* Columna izquierda vacía para compensar */}
            <Link
              to={`/admin/notificaciones`}
              className='pre'
              style={{
                  width: "33.33%",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
            >
              <p
                className='titulos-secundarios-rojos'
              >
                Ir a Notificaciones
              </p>
            </Link>

            {/* Columna del centro con el título */}
            <div
              style={{
                width: "33.33%",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <h1
                className="titulos"
              >
                Administración
              </h1>
            </div>

            {/* Columna derecha con texto y badge */}
              <Link
                to={`/admin/pre-inscriptos`}
                className='pre'
                style={{
                    width: "33.33%",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "10px"
                  }}
              >
                <p
                  className='titulos-secundarios-rojos'
                >
                  Ver pre-registros
                </p>
                <div
                  style={{
                    backgroundColor: "#BA1721",
                    width: "26px",
                    height: "26px",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#fff",
                    fontSize: "14px",
                  }}
                >
                  {preInscriptos.length}
                </div>
              </Link>
          </div>
          ) : (
            <div
              className='divPre'
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                maxWidth: "1200px",
              }}
            >

              {/* Columna del centro con el título */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <h1
                  className="titulos"
                >
                  Administración
                </h1>
              </div>
            </div>
          )}
      </section>
      <section
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "30px", 
          margin: "20px 0"
        }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            justifyContent: "center",
            maxWidth: "1500px", 
            gap: "30px", 
          }}>
          {/* Elementos */}
          {sesion.permisos?.includes("CAMPEONATOS") || sesion.super_admin === true ? (
            <ContainerAdministracion 
              link="/admin/campeonato" 
              texto="Campeonatos" 
              img="campeonato.svg" 
              textoInfo={`Campeonatos creados: ${campeonatos.length}`}
              descripcion={"Gestioná tus campeonatos"}
            />
          ) : (
            ""
          )}
          {sesion.permisos?.includes("CIRCUITOS") || sesion.super_admin === true ? (
            <ContainerAdministracion 
              link="/admin/circuito" 
              texto="Circuitos" 
              img="circuito.svg" 
              textoInfo={`Circuitos creados: ${circuito.length}`}
              descripcion={"Creá y gestioná tus circuitos"}
            />
          ) : ""}
          {sesion.permisos?.includes("CATEGORIAS") || sesion.super_admin === true ? (
            <ContainerAdministracion 
              link="/admin/categoria" 
              texto="Categorías" 
              img="categorias.svg" 
              textoInfo={`Categorías: ${categorias.length}`}
              descripcion={"Creá categorías"}
            />
          ) : ""}
          {sesion.permisos?.includes("PILOTOS") || sesion.super_admin === true ? (
            <ContainerAdministracion 
              link="/admin/pilotos" 
              texto="Pilotos" 
              img="pilotos.svg" 
              textoInfo={`Cantidad de pilotos: ${pilotos.length}`}
              descripcion={"Alta, baja y modificación de pilotos"}
            />
          ) : ""}
          {sesion.permisos.includes("CARRERAS") || sesion.super_admin === true ? (
            <ContainerAdministracion 
              link="/admin/carreras" 
              texto="Carreras" 
              img="carreras.svg" 
              textoInfo={`Cantidad de carreras: ${carreras.length}`}
              descripcion={"Creá tus próximas carreras"}
            />
          ) : ""}
          {sesion.permisos?.includes("GESTION_DE_CARRERAS") || sesion.super_admin === true ? (
            <ContainerAdministracion 
              link="/admin/inscripciones" 
              texto="Gestión Carreras" 
              img="gestion-carreras.svg" 
              textoInfo={`Carreras corridas: ${gestionCarreras.length}`}
              descripcion={"Cargar puntos, inscribir pilotos y demás"}
            />
          ) : ""}
          {sesion.permisos?.includes("RESULTADOS_GENERALES") || sesion.super_admin === true ? (
            <ContainerAdministracion 
              link="/admin/resultados" 
              texto="Resultados Generales" 
              img="resultados.svg" 
              descripcion={"Tabla de resultados de campeonato por categoría"}
            />
          ) : ""}
          {sesion.permisos?.includes("GRUPOS") || sesion.super_admin === true ? (
            <ContainerAdministracion 
              link="/admin/grupos" 
              texto="Grupos" 
              img="grupos.svg" 
              descripcion={"Armado de grupos para impresión"}
              ancho="auto"
            />
          ) : ""}
        </div>
      </section>
    </>
  );
};